/**
 * Flash Bridge Helper - Client-side JavaScript for Flash content
 * This provides the interface for Flash/ActionScript to communicate with the secure bridge
 * 
 * Usage in Flash/ActionScript:
 * 
 * 1. Get the bridge token and namespace:
 *    var token = ExternalInterface.call("eval", "window.__ruffle_bridge_token");
 *    var namespace = ExternalInterface.call("eval", "window.__ruffle_bridge_namespace");
 * 
 * 2. Call bridge methods:
 *    var result = ExternalInterface.call("eval", "window['" + namespace + "'].getMyPlayerData('" + token + "')");
 * 
 * Or use the helper functions below by including this in your Flash project:
 */

const BRIDGE_METHODS = [
    'getKeys',
    'getFrameColor',
    'getPath',
    'getGamesPath',
    'getMyPlayerData',
    'getMyPlayer',
    'getMyPlayerHex',
    'getMyPlayerId',
    'getMyLastRoom',
    'getMyPlayerNickname',
    'getPlayerObjectById',
    'getPuffleColor',
    'getCurrentServerRoomId',
    'getLocalizedFrame',
    'isItemOnMyPlayer',
    'isItemInMyInventory',
    'isMyPlayerMember',
    'playerWearingItem',
    'sendGameEvent',
    'sendGameOver',
    'sendGameOverAltLoader',
    'sendJoinLastRoom',
    'sendEndMidwayGame',
    'joinRoom',
    'buyInventory',
    'addItemToMyInventory',
    'onLoadComplete',
    'onWidgetLoadComplete',
    'startGameMusic',
    'startMusicById',
    'stopGameMusic',
    'stopMusic',
    'stampEarned',
    'stampEarnedAltLoader',
    'stampIsOwnedByMe',
    'loadCardJitsuWorld',
    'CardJitsuDownloadedAnimation',
    'sendDancingPacket',
    'addEventListener',
    'removeEventListeners',
    'closeWidget',
    'closeRoom'
]

const FlashBridgeHelper = {
    getBridgeInfo() {
        return {
            token: window.__ruffle_bridge_token,
            namespace: window.__ruffle_bridge_namespace,
            bridge: window.__ruffle_bridge_token ? window[window.__ruffle_bridge_namespace] : null
        }
    },

    callBridge(methodName, ...args) {
        const info = this.getBridgeInfo()

        if (!info.bridge || !info.token) {
            console.error('[FlashBridgeHelper] No active bridge found')
            return null
        }

        if (typeof info.bridge[methodName] !== 'function') {
            console.error('[FlashBridgeHelper] Method not found:', methodName)
            return null
        }

        try {
            return info.bridge[methodName](info.token, ...args)
        } catch (error) {
            console.error('[FlashBridgeHelper] Error calling bridge method:', methodName, error)
            return null
        }
    }
}

for (const method of BRIDGE_METHODS) {
    FlashBridgeHelper[method] = function(...args) {
        return this.callBridge(method, ...args)
    }
}

window.FlashBridgeHelper = FlashBridgeHelper

// Flash bridge helper initialized